var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('UCAppHeaderItem',{staticClass:"store",attrs:{"icon":"fa-location-dot","data-external":"header-store","title":_vm.selectedStoreName ? 'My Store' : 'Set my store',"subtitle":_vm.selectedStoreName},on:{"on-click":_vm.toggleStoresSidebar}})
}
var staticRenderFns = []

export { render, staticRenderFns }